import React from 'react';
import { Check, X } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function IsThisForYou() {
  return <section className="bg-warm-white py-[100px] px-5" data-id="element-292">
      <div className="max-w-[880px] mx-auto" data-id="element-293">
        <h2 className="font-serif text-[36px] md:text-[44px] text-primary-dark text-center mb-16" data-id="element-294">
          Is The Debt-Free System Right For You?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-295">
          {/* Left Column - YES */}
          <div className="flex flex-col" data-id="element-296">
            <div className="bg-success-green text-white rounded-t-lg p-4 text-center" data-id="element-297">
              <span className="font-sans font-bold text-[14px] uppercase tracking-wider" data-id="element-298">
                ✅ THIS IS FOR YOU IF:
              </span>
            </div>
            <div className="bg-white border border-success-green rounded-b-lg p-6 md:p-8 flex-grow" data-id="element-299">
              <ul className="space-y-4 font-sans text-[16px] text-primary-dark/80 leading-[1.8]" data-id="element-300">
                <li className="flex items-start" data-id="element-301">
                  <Check className="w-5 h-5 text-success-green mr-3 mt-1 flex-shrink-0" data-id="element-302" />
                  <span data-id="element-303">You earn $25K–$80K/year (works at every income)</span>
                </li>
                <li className="flex items-start" data-id="element-304">
                  <Check className="w-5 h-5 text-success-green mr-3 mt-1 flex-shrink-0" data-id="element-305" />
                  <span data-id="element-306">
                    You have credit cards, car loans, student loans, medical
                    debt — or all of the above
                  </span>
                </li>
                <li className="flex items-start" data-id="element-307">
                  <Check className="w-5 h-5 text-success-green mr-3 mt-1 flex-shrink-0" data-id="element-308" />
                  <span data-id="element-309">
                    You make payments but barely — and Sunday nights you feel it
                  </span>
                </li>
                <li className="flex items-start" data-id="element-310">
                  <Check className="w-5 h-5 text-success-green mr-3 mt-1 flex-shrink-0" data-id="element-311" />
                  <span data-id="element-312">You're not in crisis, but you're not in control</span>
                </li>
                <li className="flex items-start" data-id="element-313">
                  <Check className="w-5 h-5 text-success-green mr-3 mt-1 flex-shrink-0" data-id="element-314" />
                  <span data-id="element-315">You've tried budgets and they never stuck</span>
                </li>
                <li className="flex items-start" data-id="element-316">
                  <Check className="w-5 h-5 text-success-green mr-3 mt-1 flex-shrink-0" data-id="element-317" />
                  <span data-id="element-318">You can spend 15 minutes a week on your finances</span>
                </li>
                <li className="flex items-start" data-id="element-319">
                  <Check className="w-5 h-5 text-success-green mr-3 mt-1 flex-shrink-0" data-id="element-320" />
                  <span data-id="element-321">You want tools and scripts — not motivation</span>
                </li>
                <li className="flex items-start" data-id="element-322">
                  <Check className="w-5 h-5 text-success-green mr-3 mt-1 flex-shrink-0" data-id="element-323" />
                  <span data-id="element-324">
                    You're ready to stop hoping it gets better on its own
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column - NO */}
          <div className="flex flex-col" data-id="element-325">
            <div className="bg-blood-red text-white rounded-t-lg p-4 text-center" data-id="element-326">
              <span className="font-sans font-bold text-[14px] uppercase tracking-wider" data-id="element-327">
                ❌ THIS IS NOT FOR YOU IF:
              </span>
            </div>
            <div className="bg-white border border-blood-red rounded-b-lg p-6 md:p-8 flex-grow" data-id="element-328">
              <ul className="space-y-4 font-sans text-[16px] text-primary-dark/60 leading-[1.8]" data-id="element-329">
                <li className="flex items-start" data-id="element-330">
                  <X className="w-5 h-5 text-blood-red mr-3 mt-1 flex-shrink-0" data-id="element-331" />
                  <span data-id="element-332">
                    You want get-rich-quick schemes or investment tips
                  </span>
                </li>
                <li className="flex items-start" data-id="element-333">
                  <X className="w-5 h-5 text-blood-red mr-3 mt-1 flex-shrink-0" data-id="element-334" />
                  <span data-id="element-335">
                    You want someone to tell you to cut coffee and wake at 5 AM
                  </span>
                </li>
                <li className="flex items-start" data-id="element-336">
                  <X className="w-5 h-5 text-blood-red mr-3 mt-1 flex-shrink-0" data-id="element-337" />
                  <span data-id="element-338">
                    You're not willing to spend 15 minutes a week on your money
                  </span>
                </li>
                <li className="flex items-start" data-id="element-339">
                  <X className="w-5 h-5 text-blood-red mr-3 mt-1 flex-shrink-0" data-id="element-340" />
                  <span data-id="element-341">
                    You're already debt-free (genuinely — this is a different
                    book)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-342">
                  <X className="w-5 h-5 text-blood-red mr-3 mt-1 flex-shrink-0" data-id="element-343" />
                  <span data-id="element-344">
                    You want inspiration instead of step-by-step tools
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-16" data-id="element-345">
          <CTAButton subText="Works at every income · 15 minutes a week" data-id="element-346">
            THIS IS FOR ME — GET THE SYSTEM → $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}